/**
 * Service modules — docs/04-MODULE-CONTRACTS.md §5.5.
 * No UI. Shape recognition, autosave, presence, archive trigger.
 */
/** SRS C5 — timings for the Smart Pen. */
export const SNAP_EVALUATION_WINDOW_MS = 250;
export const SNAP_MORPH_DURATION_MS = 150;
export const UNDO_SNAP_PILL_DURATION_MS = 4000;
/** Strokes shorter than this in canvas units are never snapped. */
export const MIN_SNAPPABLE_LENGTH_CANVAS_PX = 20;
//# sourceMappingURL=services.js.map